import { _data, _tyresSpecs, TyreDetailLineModel } from './data.tyre.js';
import { _utilities } from '../utilities.js';
import { _wheelPlansPanel } from './wheelplans.js';

class TyreDetailsSummary  {
    displayTyresSelection (moveToHandler, navigatingForward) {   
        this.moveTo = (sectionName) => {
            moveToHandler(sectionName);
        };

        const wheelDetailsModel = _data.vehicle.tyreDetailLines;
        let $parentContainer = $('#tyreDetailSummaryContainer .card-body');
        let wheelplan = _wheelPlansPanel._wheelPlan;

        // put the tyre details in spefic order
        var order = ["NSF", "OSF", "NSR", "OSR", "NSR2", "OSR2", "SPARE"];
        _.sortBy(_data.vehicle.tyreDetailLines, function (obj) {
            return _.indexOf(order, obj.title);
        });

        if (navigatingForward) {
            $('.nextButton').hide();
            this.resetContainer($parentContainer);

            var top = (dataPosition, title, width, ratio, diameter, load, rating, construction) =>
                `<div class="row mb-2" data-position="${dataPosition}">
                    <div class="col-sm-12 col-md text-center p-2"><span class="d-md-none font-weight-bold">Side: </span>${wheelplan[title].Name}</div>
                    <div class="col-sm-12 col-md col text-center p-2"><span class="d-md-none font-weight-bold">Dimensions: </span>${width}/${ratio} R${diameter} ${load}${rating} ${construction}</div>
                    
                    <div class="col-sm-12 col-md text-center"><span class="d-md-none font-weight-bold">Brand: </span>
                        <input id="${title}_Brand" class="form-control tyreDetailBrand" data-validate="false" data-wheel="${title}" name="${title}_Brand" data-value="0" data-label="brand_label" />
                    </div>`;

            var middle = (title) =>
                `<div class="col-sm-12 col-md text-center"><span class="d-md-none font-weight-bold">Pattern: </span>
                    <input id="${title}_TyreDetailPattern" class="form-control tyreDetailPattern" data-wheel="${title}" name="${title}_Pattern" data-value="0" data-label="pattern_label" />
                </div>`;

            var bottom = (title) =>
                `<div class="col-sm-12 col-md text-center"><span class="d-md-none font-weight-bold">Replacement Reason: </span>
                    <input id="${title}_TyreDetailDamage" class="form-control tyreDetailDamage" data-validate="false" data-wheel="${title}" name="${title}_DamageType" /></span>
                </div>
            </div>`;


            if (!wheelDetailsModel) {
                return;
            }

            for (const key in wheelDetailsModel) {
                const element = wheelDetailsModel[key];

                var html = top(element.wheelSelected, element.title, element.width, element.ratio, element.diameter, element.load, element.rating, element.construction)
                    + (_utilities.IsMfs()
                        ? middle(element.title)
                        : '')
                    + bottom(element.title);

                $parentContainer.append(html);

                this.bindDrowDowns($parentContainer, element.title);

                if (_utilities.IsMfs()) {
                    //Calling bind, will stop free form text entry
                    this.setPatterns(element.title);
                }

                $($parentContainer).find(`#${element.title}_Brand`)[0].value = element.brand;
            };

            this.bindConfirmBtnClickHandler($parentContainer);
            this.bindEditButtonHandler($parentContainer);
        }
    }

    setPatterns = (wheel, values = null) => {
        let _this = this;
        let $parentContainer = $('#tyreDetailSummaryContainer .card-body');
        let tyreDetailLineModel = _data.vehicle.tyreDetailLines.find(attr => attr.wheelSelected === wheel);

        if (values == null) {
            tyreDetailLineModel.pattern = null;
        }

        $($parentContainer).find(`#${wheel}_TyreDetailPattern`).kendoDropDownList({
            dataSource: {
                data: values
            },
            change: function () {
                var pattern = this.value();

                if (pattern == 'Choose') {
                    pattern = null;
                }

                tyreDetailLineModel.pattern = pattern;
            }
        });
    }

    showPattern = (model) => {
        if (_utilities.IsMfs()) {
            var wheel = model.wheelSelected;

            $.ajax({
                url: 'Tyres/GetPatterns',
                contentType: "application/json",
                dataType: "json",
                type: 'post',
                data: JSON.stringify({
                    brand: model.brand,
                    width: model.width,
                    profile: model.ratio,
                    rim: model.diameter,
                    load: model.load,
                    speed: model.rating,
                    construction: model.construction
                }),
                success: (patterns) => {
                    if (patterns.length > 0) {
                        patterns = ['Choose', ...patterns];
                    }

                    this.setPatterns(wheel, patterns);
                }
            });
        }
    }

    bindDrowDowns($parentContainer, wheel) {
        let _this = this;
        TyreDetailLineModel.getTyreBrands(function (brands) {        
        var $input = $($parentContainer).find(`#${wheel}_Brand`);
            $input.kendoAutoComplete({
                dataSource: brands,
                dataTextField: 'name',
                filter: 'contains',
                placeholder: 'Enter Tyre Brand',
                select: function (e) {
                    var dataItem = this.dataItem(e.item.index());
                    $(this).data('value', dataItem.id);

                    let $this = $(e.sender.element);
                    let $container = $this.parents('.detailcontainer');
                    let labelClass = '.' + $this.data('label');
                    let $displaySpan = $container.find(labelClass);
                    let currentValue = dataItem.name;
                    $displaySpan.text(currentValue);
                    $displaySpan.addClass('font-weight-bold').addClass('text-info');
                },
                change: function()  {
                    var found = false;
                    var value = this.value();
                    var wheel = this.element.data('wheel');
                    var data = this.dataSource.view();

                    for (var idx = 0, length = data.length; idx < length; idx++) {
                        if (data[idx].name === value) {
                            found = true;
                            break;
                        }
                    }

                    let tyreDetailLineModel = _data.vehicle.tyreDetailLines.find(attr => attr.wheelSelected === wheel);

                    // Only allow values in the dataSource list
                    if (!found) {
                        this.value("");
                        $('.nextButton').hide();
                        tyreDetailLineModel.brand = null;

                        if (_utilities.IsMfs()) {
                            _this.setPatterns(wheel);
                        }
                    } else {
                        tyreDetailLineModel.brand = value;
                        _this.showPattern(tyreDetailLineModel);

                        if (_this.tyreDetailLineValid()) {
                            $('.nextButton').show();
                        }
                    }
                }
            });
        });

        $($parentContainer).find(`#${wheel}_TyreDetailDamage`).kendoDropDownList({
            dataSource: {
                transport: {
                    read: {
                        url: '/tyres/gettyreinitialreasons?includeDefaultOption=true',
                        dataType: 'json'
                    }
                }
            },
            dataTextField: 'name',
            dataValueField: 'id',
            change: function () {
                var value = this.value();

                if (value !== '' && value !== '0') {
                    let tyreDetailLineModel = _data.vehicle.tyreDetailLines.find(attr => attr.wheelSelected === wheel);
                    tyreDetailLineModel.damageType = {
                        Id: value,
                        Name: $(this.element).data('kendoDropDownList').text()
                    };

                    if (_this.tyreDetailLineValid()) {
                        $('.nextButton').show();
                    }
                } else {
                    $('.nextButton').hide();
                }
            }
        });
    }

    tyreDetailLineValid(checkPattern = false) {
        let isValid = true;    

        for (const key in _data.vehicle.tyreDetailLines) {
            const element = _data.vehicle.tyreDetailLines[key];

            if (element.damageType === null || element.damageType.Id === '0') {
                isValid = false;
            }

            if (element.brand === '' || element.brand === null) {
                isValid = false;
            }

            if (checkPattern) {
                if (_utilities.IsMfs()) {
                    var $parentContainer = $('#tyreDetailSummaryContainer .card-body');
                    var patternControl = $($parentContainer).find(`#${element.wheelSelected}_TyreDetailPattern`);
                    var patterns = patternControl.data("kendoDropDownList").dataSource.view();

                    if (patterns.length > 0) {
                        if (element.pattern == null) {
                            isValid = false;
                        }
                    }
                }
            }
        }

        return isValid;
    }

    resetContainer ($parentContainer) {
        $parentContainer.html('');
        $('#confirmTyreSelection').show().parent().addClass('text-right').removeClass('text-center');
        const $btnCollection = $parentContainer.closest('.card').find('.btn');
        $parentContainer.closest('.card').find('.animated-tick-wrapper').remove();
        $btnCollection.removeAttr('disable').removeClass('disabled').css('cursor', 'pointer'); 
        $('#tyreDetailsConfirmedInput').val('');      
    }

    bindConfirmBtnClickHandler($parentContainer) {
        let _this = this;
        $('#confirmTyreSelection').off();
        $('#confirmTyreSelection').on('click', event => {
            if (_this.tyreDetailLineValid()) {
                let $btn = $(event.target);
                let $btnCollecton = $parentContainer.closest('.card').find('.btn');
                let animatedSvgTick = (_utilities.IsEdgeBrowser() || _utilities.IsInternetExplorer()) === true ? `<i class="far fa-check-circle text-success" style="font-size:1.2em;"></i>` :
                    `<div class="animated-tick-wrapper">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" 
                viewBox="0 0 98.5 98.5" enable-background="new 0 0 98.5 98.5" xml:space="preserve"> 
                <path class="checkmark" fill="none" stroke-width="8" stroke-miterlimit="10" d="M81.7,17.8C73.5,9.3,62,4,49.2,4 
                C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"/>
                </svg>
            </div>`;

                $btnCollecton.prop('disable', 'disabled').addClass('disabled').css('cursor', 'not-allowed');
                $btnCollecton.off();
                $btn.hide().parent().removeClass('text-right').addClass('text-center');
                $('#tyreDetailSummaryContainer .card-footer').append(animatedSvgTick);
                $('#tyreDetailsConfirmedInput').val(true);
                $('.nextButton').show();
            }
        });
    }

    bindEditButtonHandler($parentContainer) {
        $('.btn-warning').off();
        $parentContainer.find('.btn-warning').on('click', (event) => {            
            const tyrePosition = $(event.target).closest('.row').data('position');
		    this.moveTo(tyrePosition.toLowerCase());
        });
    }

    GetValidator() {
        var _this = this;

        return $('#tyreDetailsSummarySection').kendoValidator({
            rules: {
                confirmationSelected: function () {
                    return _utilities.IsMfs()
                        ? _this.tyreDetailLineValid(true)
                        : true;
                }
            }
        }).data('kendoValidator');
    }
}

export let _tyreDetailsSummaryPanel = new TyreDetailsSummary();